import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const AccountLedgerBasicInfoComponent = ({
    id, handleInnerBasicFormChange, selectedAccountLedgers, accountCategoriesList
}: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                    <InputContainer
                        label="Account Category"
                        labelField="CategoryName"
                        list={accountCategoriesList}
                        onValueChange={(event: any, newValue: any) => {
                            handleInnerBasicFormChange(
                                event.target.value,
                                'AccountCategoryId',
                            );
                        }}
                        optionName='Choose CategoryName'
                        type="select"
                        value={selectedAccountLedgers?.AccountCategoryId}
                        valueField="Id"
                    />
                        <InputContainer
                            label="Ledger Name"
                            name="LedgerName"
                            onValueChange={(event: any) => {
                                handleInnerBasicFormChange(
                                    event.target.value,
                                    'LedgerName',
                                );
                            }}
                            type="text"
                            value={selectedAccountLedgers?.LedgerName}
                        />
                        <InputContainer
                            label="Description"
                            name="Description"
                            onValueChange={(event: any) => {
                                handleInnerBasicFormChange(
                                    event.target.value,
                                    'Description',
                                );
                            }}
                            type="text"
                            value={selectedAccountLedgers?.Description}
                        />
                        <InputContainer
                            label="Opening Balance"
                            name="OpeningBalance"
                            onValueChange={(event: any) => {
                                handleInnerBasicFormChange(
                                    event.target.value,
                                    'OpeningBalance',
                                );
                            }}
                            type="number"
                            value={selectedAccountLedgers?.OpeningBalance}
                        />
                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Basic Info"
            />
        </>
    )
}
export default AccountLedgerBasicInfoComponent;
